export enum PaymentGatewayConnector {
    None = 0,
    Spreedly = 1,
}